<app-nav></app-nav>
<br>
<div class="container">
    <h1>Success!</h1>
    <p>Thank you for submitting your information to the clearance portal.</p>
    <p>You may now close this page.</p>
</div>